export default "https://cdn-static-staging.gokick.com/assets/8be3c2df1b703b0455f7e6e91c436c85253a82ea/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";